function NavBar({ text }) {
  return (
    <h1 class="text-black text-5xl font-medium py-2 rounded w-auto">{text}</h1>
  );
}

export default NavBar;
